import jwtDecode from 'jwt-decode'
import fetchAdUser from './fetchAdUser'
// import fetchUser from './fetchUser'

import { USER_LOGIN_REDIRECT, USER_AUTH_KEY } from '../../utils/constants'

export const SET_CREATE_SESSION_FLAG = 'SET_CREATE_SESSION_FLAG'
export const SET_ERROR = 'SET_ERROR'
export const SET_REDIRECT_ROUTE = 'SET_REDIRECT_ROUTE'
export const SET_USER = 'SET_USER'
export const SET_AUTH_MODE = 'SET_AUTH_MODE'

export const createSession = (id_token, client_info, session_state, state) => {
  return async (dispatch, getState) => {
    const { isCreatingSession } = getState()
    var ttlMinutes = 4 * 60 // two hours
    if (isCreatingSession) return

    dispatch({ type: SET_CREATE_SESSION_FLAG, isCreatingSession: true })

    try {
      if (id_token) {
        dispatch({ type: SET_AUTH_MODE, authMode: 'msid' })
        // If id_token is present it is a AD authentication. Validate the token at the backend and
        // get back the user information along with the session cookies.

        const user = await fetchAdUser(
          id_token,
          client_info,
          session_state,
          state
        )
        dispatch({ type: SET_USER, user })
      } else {
        dispatch({ type: SET_AUTH_MODE, authMode: 'ohid' })

        if (
          process.env.REACT_APP_DEVELOPMENT_MODE === undefined ||
          process.env.REACT_APP_DEVELOPMENT_MODE === 'true'
        ) {
          // TODO: add this in when backend is ready! This is OAuth 2.0 flow to
          // check the existence of user in the authenticating system.
          // const user = await fetchUser(TEST_USER_EMAIL)
          const user = {
            firstName: 'Rizwaan',
            lastName: 'Mohammad',
            email: 'mohammad.rizwaan@optum.com',
            username: 'mrizwaan',
            phone: '+19999999999',
            role: 'Admin',
            preferences: {
              timeZone: 'America/Chicago',
              timeZoneDisplay: 'DD/MM/YYYY, h:mm:ss A z',
            },
            usercomponents: ['home', 'dashboard', 'flutabs', 'fludetails'],
            expiry: new Date().getTime() + ttlMinutes * 60 * 1000,
          }
          window.localStorage.setItem('requester', JSON.stringify(user))
          window.localStorage.setItem('requesterinc', JSON.stringify(user))
          dispatch({ type: SET_USER, user })
        } else {
          const authenticate = async () => {
            debugger
            await fetch(
              `${process.env.REACT_APP_BACKEND_BASE_URL}/getuserprofiledetails`,
              {
                method: 'get',
                headers: {
                  'Content-Type': 'application/json',
                },
                withCredentials: true,
                credentials: 'include',
              }
            )
              .then((response) => response.json())
              .then((data) => {
                if (data.response_code === 200) {
                  let userData = data.response_data
                  const user = {
                    firstName: userData.firstname,
                    lastName: userData.lastname,
                    email: userData.email,
                    username: userData.username,
                    sortName: userData.sortname,
                    phone: userData.phone,
                    role: userData.role,
                    preferences: {
                      timeZone: 'America/Chicago',
                      timeZoneDisplay: 'DD/MM/YYYY, h:mm:ss A z',
                    },
                    expiry: new Date().getTime() + ttlMinutes * 60 * 1000,
                    uuid: userData.uuid,
                    userid: userData.userid,
                    usercomponents: userData.usercomponents.split(','),
                  }
                  const userinc = {
                    username: userData.username,
                    firstName: userData.firstname,
                    lastName: userData.lastname,
                    role: userData.role,
                    email: userData.email,
                    phone: userData.phone,
                    preferences: {
                      timeZone: 'America/Chicago',
                      timeZoneDisplay: 'DD/MM/YYYY, h:mm:ss A z',
                    },
                    expiry: new Date().getTime() + ttlMinutes * 60 * 1000,
                    uuid: userData.uuid,
                    userid: process.env.REACT_APP_APPLICATION_ID,
                  }
                  window.localStorage.setItem('exp', user.expiry)
                  window.localStorage.setItem('requester', JSON.stringify(user))
                  window.localStorage.setItem(
                    'requesterinc',
                    JSON.stringify(userinc)
                  )
                  dispatch({ type: SET_USER, user })
                } else if (data.response_code === 400) {
                } else if (data.response_code === 401) {
                } else {
                }
              })
              .catch((err) => {
                console.log(err)
              })
          }

          await authenticate()
        }
      }
      dispatch({ type: SET_REDIRECT_ROUTE, route: '/' })
      dispatch({ type: SET_CREATE_SESSION_FLAG, isCreatingSession: false })
    } catch (error) {
      dispatch({ type: SET_ERROR, error })
      dispatch({ type: SET_CREATE_SESSION_FLAG, isCreatingSession: false })
    }
  }
}

export const clearSession = () => {
  return async (dispatch) => {
    window.localStorage.removeItem(USER_AUTH_KEY)
    window.localStorage.removeItem(USER_LOGIN_REDIRECT)
    dispatch({ type: SET_USER, user: null })
  }
}

export const preventNextRedirect = () => ({
  type: SET_REDIRECT_ROUTE,
  route: null,
})
